module.exports = "<p>双色图标</p>\n";